import React, { useState } from "react";
import {
  getSanctionTypeLabel,
  getSanctionTypeStyle,
  getDetectionTypeBadge,
  getReasonLabel,
} from "./inscriptionHelpers";
import { INFORMATIONS_COMPLEMENTAIRES_LABELS } from "../../EpFormV2/EpRecipientsV2/informationsComplementairesConstants";

const InscriptionCardContext = ({ inscription }) => {
  const sanctionStyle = getSanctionTypeStyle(inscription.type);
  const detectionBadge = getDetectionTypeBadge(inscription.detectionType);
  const [infosOpen, setInfosOpen] = useState(false);

  return (
    <div
      className="p-2 rounded h-100"
      style={{
        background: "#f8fafc",
        borderLeft: `3px solid ${sanctionStyle.border}`,
      }}
    >
      {/* Type badge */}
      <div className="d-flex align-items-center mb-2" style={{ gap: 8 }}>
        <span
          className="d-inline-flex align-items-center px-2 py-1 rounded"
          style={{
            background: sanctionStyle.bg,
            color: sanctionStyle.color,
            fontSize: 12,
            fontWeight: 700,
            gap: 5,
          }}
        >
          <i
            className={`fa ${sanctionStyle.icon}`}
            style={{ fontSize: 11 }}
          />
          {getSanctionTypeLabel(inscription.type)}
        </span>
        {detectionBadge && (
          <span
            className="d-inline-flex align-items-center px-2 py-1 rounded"
            style={{
              background: detectionBadge.bg,
              color: detectionBadge.color,
              fontSize: 11,
              fontWeight: 600,
              border: `1px solid ${detectionBadge.border}33`,
            }}
          >
            {detectionBadge.label}
          </span>
        )}
      </div>
      {/* Motif */}
      <div
        style={{
          fontSize: 12,
          color: "#475569",
          lineHeight: 1.5,
        }}
      >
        <span
          style={{
            color: "#94a3b8",
            fontWeight: 600,
            fontSize: 11,
            textTransform: "uppercase",
            letterSpacing: 0.5,
          }}
        >
          Motif principal
        </span>
        <div className="mt-1" style={{ fontWeight: 500 }}>
          {getReasonLabel(inscription.motif)}
        </div>
      </div>

      {/* Informations complémentaires — dropdown */}
      {inscription.additionalInformations?.length > 0 && (
        <div className="mt-2" style={{ position: "relative" }}>
          <button
            type="button"
            className="btn btn-sm d-inline-flex align-items-center"
            onClick={() => setInfosOpen((prev) => !prev)}
            style={{
              fontSize: 11,
              fontWeight: 600,
              color: "#0369a1",
              background: "#f0f9ff",
              border: "1px solid #bae6fd",
              borderRadius: 6,
              padding: "3px 10px",
              gap: 5,
            }}
          >
            <i className="fa fa-info-circle" style={{ fontSize: 10 }} />
            Infos complémentaires
            <span
              className="badge badge-pill"
              style={{
                background: "#0369a1",
                color: "#fff",
                fontSize: 10,
                marginLeft: 2,
              }}
            >
              {inscription.additionalInformations.length}
            </span>
            <i
              className={`fa fa-chevron-${infosOpen ? "up" : "down"} ml-1`}
              style={{ fontSize: 9 }}
            />
          </button>

          {infosOpen && (
            <div
              className="rounded mt-1 p-2"
              style={{
                background: "#fff",
                border: "1px solid #bae6fd",
                boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
              }}
            >
              <div className="d-flex flex-column" style={{ gap: 4 }}>
                {inscription.additionalInformations.map((info) => (
                  <div
                    key={info}
                    className="d-flex align-items-center px-2 py-1 rounded"
                    style={{
                      fontSize: 11,
                      fontWeight: 500,
                      color: "#0369a1",
                      background: "#f0f9ff",
                      gap: 6,
                    }}
                  >
                    <i
                      className="fa fa-check"
                      style={{ fontSize: 9, flexShrink: 0 }}
                    />
                    {INFORMATIONS_COMPLEMENTAIRES_LABELS[info] || info}
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default InscriptionCardContext;
